import { INutritionForm } from "@/types/Nutrition.types";

export const NutritionFormInitial: INutritionForm = {
    // Auto-populated fields
    sectionName: '',
    productSpecificationName: '',
    version: '',
    isNutritionValidated: false,
    nutritionInfoRequired: 'Yes',
    
    // User input fields
    nutritionDataSubmissionMethod: '',
    factsPanelFormat: '',
    footnote: '',
    headingText: '',
    calorieContent: '',
    columnsToDeclare: '',
    servingSizeAndHouseholdMeasure: '',
    servingsPerContainer: '',
    servingQuantityForCalculation: '',
    dvCalculationBasis: '',
    pdcaas: '',
    rdiCalculationBasis: '',
    calculateAmounts: '',
    dataSource: '',
    nutrients: [],
    documents: [],
    footnoteAdditionStatements: [],
    guaranteedAnalysis: ''
};
